import React, { PureComponent } from 'react'
import routes from './routes'
import {Provider} from 'mobx-react'
import store from 'store'
import { LocaleProvider } from 'antd'
import zh_CN from 'antd/lib/locale-provider/zh_CN'   //eslint-disable-line
import 'moment/locale/zh-cn'
// 加载基础样式与布局
import './styles/app'

// Render the main component into the dom
class App extends PureComponent {
  render () {
    return (
      <LocaleProvider locale={zh_CN} >
        <Provider {...store}>
          {routes()}
        </Provider>
      </LocaleProvider>
    )
  }
}
export default App



// WEBPACK FOOTER //
// ./src/App.js